import React, { useRef, useEffect } from "react";
import { motion } from "framer-motion";
import Confetti from "react-confetti";
import ReactCanvasConfetti from "react-canvas-confetti";
import { useWindowSize } from "@react-hook/window-size";

const QuizResultModal = ({ score, total, handleReview, onNext, onHome }) => {
  const [width, height] = useWindowSize();
  const success = score >= Math.ceil(total / 2);
  const refAnimationInstance = useRef(null);

  const makeShot = () => {
    if (refAnimationInstance.current) {
      refAnimationInstance.current({
        particleCount: 100,
        spread: 160,
        origin: { y: 0.6 },
      });
    }
  };

  useEffect(() => {
    if (success) {
      const interval = setInterval(makeShot, 500);
      setTimeout(() => clearInterval(interval), 2500);
    }
  }, [success]);

  const getMessage = () => {
    return success
      ? "🎉 Félicitations ! Tu peux passer au niveau suivant !"
      : "💡 Tu dois obtenir la moyenne pour passer. Recommence le quiz !";
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      {success && (
        <>
          <Confetti width={width} height={height} />
          <ReactCanvasConfetti
            refConfetti={(instance) =>
              (refAnimationInstance.current = instance)
            }
            style={{
              position: "fixed",
              pointerEvents: "none",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0,
              zIndex: 1000,
            }}
          />
        </>
      )}
      <motion.div
        className="bg-white rounded-2xl shadow-lg p-8 text-center w-full max-w-md z-50"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 200 }}
      >
        <h2 className="text-2xl font-bold mb-4">Résultat du Quiz</h2>
        <p className="text-xl mb-2">
          Score :{" "}
          <span className="font-bold">
            {score} / {total}
          </span>
        </p>
        <p className="mb-6">{getMessage()}</p>

        <div className="flex flex-col gap-3">
          <button
            onClick={onNext}
            className={`px-4 py-2 rounded-md text-white font-semibold ${
              success
                ? "bg-green-600 hover:bg-green-700"
                : "bg-gray-400 cursor-not-allowed"
            }`}
            disabled={!success}
          >
            Continuer
          </button>

          <button
            onClick={handleReview}
            className="px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold rounded-md"
          >
            Review
          </button>

          <button
            onClick={onHome}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-md"
          >
            Retour à l'accueil
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default QuizResultModal;
